<template>
  <div class="banquan">
    Copyright © 2023-present 成都比程科技有限公司 All rights reserved.
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style  scoped>
.banquan {
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #909399;
  width: 100%;
  background: #f5f7fa;
}
@media screen {
  .banquan {
    font-size: 10px;
    line-height: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/copyright.vue